// <script src="{{ 'c_subscription-page.js' | asset_url }}" defer="defer"></script>

// モーダル(dialogタグ)のJavaScript

const productModals = document.querySelectorAll('.product__modal');
const productModalOpens = document.querySelectorAll('.js-product-modal-open');
const productModalCloses = document.querySelectorAll('.js-product-modal-close');



// 共通のモーダルクローズ処理関数
function closeModal(modal) {
    modal.close();

    // body, html 要素からクラスを削除
    document.body.classList.remove("is-fixed");
    document.documentElement.classList.remove("is-fixed");

    // footer, main 要素からクラスを削除
    const footerMain = document.querySelectorAll("footer, main");
    footerMain.forEach(function (element) {
        element.classList.remove("scrollbar-gutter");
    });
}

// モーダルを開くとき
productModalOpens.forEach(function (productModalOpen) {
    productModalOpen.addEventListener('click', function (event) {

        // ↓そのopenボタンに対応するdialogタグ(次の兄弟要素)を表示
        const modal = this.nextElementSibling;
        modal.showModal();

        // ↓ ボディ要素に 'is-fixed' クラスを追加
        document.body.classList.add('is-fixed');
        document.documentElement.classList.add("is-fixed"); // または html要素もクラスを追加

        // ↓ main要素とfooter要素を取得して定義
        const footerMain = document.querySelectorAll('footer, main');

        footerMain.forEach(function (element) {
            // main要素とfooter要素に'scrollbar-gutter' クラスを追加
            element.classList.add('scrollbar-gutter');
        });

        // エスケープキーでモーダルを閉じるイベントリスナーを追加
        modal.addEventListener('keydown', function onKeyDown(event) {
            if (event.key === 'Escape') {
                closeModal(modal);
                modal.removeEventListener('keydown', onKeyDown); // イベントリスナーを削除
            }
        });
    });
});

// モーダルを閉じるとき
productModalCloses.forEach(function (productModalClose) {
    productModalClose.addEventListener("click", function (event) {
        const modal = this.closest('.product__modal');
        closeModal(modal);
    });
});

// 背景クリックでも閉じる
productModals.forEach(function (productModal) {
    productModal.addEventListener("click", function (event) {
        if (event.target.closest('.product__modal__inner') === null) {
            closeModal(productModal);
        }
    });
});

// フォーカストラップ制御
const productModalFocusTraps = document.querySelectorAll(".product__modal__focus-trap");

productModalFocusTraps.forEach(function (productModalFocusTrap) {
    productModalFocusTrap.addEventListener("focus", function (event) {
        this.closest('.product__modal').lastElementChild.querySelector(".js-product-modal-top").focus();
    });
});
